// Admin-Panel: Query-Keys und Anwenden von Socket-Ereignissen (BRIDGE_STATUS_UPDATE, PLATFORM_LIMITS_UPDATE).
// Der Integrator ruft applyBridgeStatus/applyLimits aus dem Socket-Handler der Shell auf.
import type { AdminStatsDto, BridgeStatusDto, PlatformLimits } from '@lagerfeuer/shared';
import type { QueryClient } from '@tanstack/react-query';

export const ADMIN_QUERY_ROOT = ['admin'] as const;
export const ADMIN_STATS_KEY = ['admin', 'stats'] as const;
export const ADMIN_STORAGE_KEY = ['admin', 'storage'] as const;
export const ADMIN_USERS_KEY = ['admin', 'users'] as const;
export const ADMIN_SERVERS_KEY = ['admin', 'servers'] as const;
export const ADMIN_LIMITS_KEY = ['admin', 'limits'] as const;
export const ADMIN_BRIDGE_KEY = ['admin', 'bridge'] as const;
export const ADMIN_AVAILABLE_GUILDS_KEY = ['admin', 'bridge', 'available-guilds'] as const;
export const ADMIN_AUDIT_KEY = ['admin', 'audit'] as const;
export const ADMIN_LOGS_KEY = ['admin', 'logs'] as const;

export const adminUserKey = (id: string) => ['admin', 'users', 'detail', id] as const;

/** BRIDGE_STATUS_UPDATE: Brückenstatus ersetzen (auch die Kurzinfo im Dashboard). */
export function applyBridgeStatus(queryClient: QueryClient, status: BridgeStatusDto): void {
  queryClient.setQueryData<BridgeStatusDto>(ADMIN_BRIDGE_KEY, status);
  queryClient.setQueryData<AdminStatsDto>(ADMIN_STATS_KEY, (old) => (old ? { ...old, bridge: status } : old));
}

/** PLATFORM_LIMITS_UPDATE: Limits ersetzen. */
export function applyLimits(queryClient: QueryClient, limits: PlatformLimits): void {
  queryClient.setQueryData<PlatformLimits>(ADMIN_LIMITS_KEY, limits);
}
